import { observer } from 'mobx-react-lite'
import { useDocStore } from 'stores/DocStore'
import { ChevronRight } from 'blaze-ui/icons/24'
import { Button } from 'common/Prose/Toolbar/ToolbarBravo/WriterFormatToolbar/Button'
import { Comment } from 'types'

export const NextItemButton = observer(() => {
  const docStore = useDocStore()
  const { collabItemsStore, orderedFilteredCollabItems } = docStore
  const selectedItemIndex = orderedFilteredCollabItems.findIndex(
    (item) => (item.item as Comment).id === collabItemsStore.selectedId,
  )

  const nextIndex = selectedItemIndex + 1
  const nextComment = orderedFilteredCollabItems[nextIndex]?.item as Comment

  const selectNext = () => {
    if (!nextComment) return

    if (nextComment.uuid) collabItemsStore.select(nextComment.uuid)
    collabItemsStore.selectById(nextComment.id)
    const comment = docStore.rootStore.comments.get(nextComment.id)

    if (!comment) return
    docStore.rootStore.comments.select(comment.id)
  }

  return <Button isDisabled={!nextComment} aria-label="Next Item" icon={ChevronRight} onPress={selectNext} />
})
